import { SETTINGS } from '../../config/settings';

type T = string | string[] | number;

export const PUBLICATIONS = '/publications';

export const COMPANIES = '/companies';
export const COMPANY = (companyId: T) => `${COMPANIES}/${companyId}`;
export const NEW_COMPANIES = `${COMPANIES}/new`;
export const EDIT_COMPANY = (companyId: T) => `${COMPANY(companyId)}/edit`;
export const COMPANY_IMAGE = (companyId: T) => `${COMPANY(companyId)}/image`;

export const COMPANIES_ESTABLISHMENTS = (companyId: T) =>
  `${SETTINGS.public.urlPublicationWeb}/companies/${companyId}/establishments`;

export const COMPANIES_PUBLICATIONS = (companyId: T) =>
  `${SETTINGS.public.urlPublicationWeb}/companies/${companyId}/publications`;

export const MANAGERS = '/moderate/managers';
export const MANAGERS_ACCOUNT = (accountId: T) => `${MANAGERS}/${accountId}`;

export const MODERATE_COMPANIES = '/moderate/companies';
export const MODERATE_COMPANIES_PUBLICATIONS = (companyId: T) =>
  `${SETTINGS.public.urlPublicationWeb}${MODERATE_COMPANIES}/${companyId}/publications`;
export const MODERATE_COMPANY = (companyId: T) =>
  `${MODERATE_COMPANIES}/${companyId}`;
export const MODERATE_COMPANY_CREATE = `${MODERATE_COMPANIES}/new`;
export const MODERATE_COMPANY_EDIT = (companyId: T) =>
  `${MODERATE_COMPANY(companyId)}/edit`;
